import { Fragment, useEffect } from "react";
import { useAppDispatch } from "../../ReduxToolkit/Hooks";
import { fetchChatMemberApiData, fetchChatsApiData } from "../../ReduxToolkit/Reducers/Messenger/Chat";
import TemplateCustomizer from "../TemplateCustomizer";
import AppSidebarChat from "./AppSidebarChat";
import ChatBoard from "./ChatBoard";
import LeftSidebarChat from "./LeftSidebarChat";
import MainSidebar from "./MainSidebar";
import ProfileSection from "./ProfileSection";
import VideoCall from "./ChatBoard/PrivateChat.tsx/ChatHeader/CallModal/VideoCall";
import AudioCall from "./ChatBoard/PrivateChat.tsx/ChatHeader/CallModal/AudioCall";

const MessengerContainer = () => {
  useEffect(() => document.body.classList.add("main-page"), []);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatsApiData());
  }, [dispatch]);
  return (
    <Fragment>
      <div className="chatzy-container sidebar-toggle">
        <MainSidebar />
        <LeftSidebarChat />
        <ChatBoard />
        <ProfileSection />
        <AppSidebarChat />
      </div>
      <TemplateCustomizer />
      <VideoCall />
      <AudioCall />
    </Fragment>
  );
};

export default MessengerContainer;
